<template>
	<div>
		<a-dialog>
			<div class="checkmark" v-html="$t('home')"></div>
			<a-button :to="{ name: 'survey' }" class="home__start">
				{{ $t("startButtonCaption") }}
			</a-button>
		</a-dialog>
	</div>
</template>

<script>
import aButton from "@/components/Button";
import aDialog from "@/components/Dialog";
import RouterGuards from "../mixins/RouterGuards";

export default {
	components: {
		aButton,
		aDialog,
	},
	mixins: [RouterGuards],
	i18n: {
		messages: {
			en: {
				startButtonCaption: "Start quick scan",
			},
			nl: {
				startButtonCaption: "Start de scan",
			},
		},
	},
};
</script>

<style lang="scss">
@import "@/styles/checkmark.scss";

@media only screen and (max-width: $mobile-breakpoint) {
	.home__start {
		width: 100%;
	}
}
</style>
